import * as React from 'react';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import b_ from 'b_';
import { compose } from 'recompose';

import './index.scss';

import * as appleIcon from './static/img/m-interface_apple.png';
import * as appleIcon_2x from './static/img/m-interface_apple@2x.png';
import * as appleIcon_3x from './static/img/m-interface_apple@3x.png';

const b = b_.with('stock-landing-demo');

interface Props {}

type Enhanced = Props & InjectedTranslateProps;

const enhance = compose<Enhanced, Props>(translate);

export const Demo: React.FC<Enhanced> = ({ t }) => (
  <div className="invest-landing-section invest-landing-section_results-tracking">
    <div className="invest-landing-dropdown invest-landing-dropdown_no-wrapper">
      <div className="invest-landing__content">
        <div className="invest-landing-demo">
          <div className="invest-landing-dropdown__row">
            <div className="invest-landing-section__column invest-landing-section__column_col-12 invest-landing-section__column_gap-right-4">
              <div className="invest-landing-section__title">{t('Tracking results')}</div>
              <div className="invest-landing-dropdown__text">
                <p>{t('Stocks tracking results paragraph #1')}</p>
                <br />
                <p>{t('Stocks tracking results paragraph #2')}</p>
              </div>
            </div>
            <div className="invest-landing-section__column invest-landing-section__column_tracking-results">
              <img
                className={b('img')}
                src={appleIcon}
                srcSet={`${appleIcon_2x} 2x, ${appleIcon_3x} 3x`}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default enhance(Demo);
